<template>
<div class="container margin-t-large pb-0">
    <div class="row m-0">
        <div class="col-lg-5 dive-tagline ">
            <h3 class="font-heading-1 font-white font-family-concended m-0">Follow your curiosity and learn more about the world of coffee</h3>
        </div>
        <div class="col-lg-7 dive-content">
            <ul>
                <li><span class="font-black">Explore the coffee growing regions and how Starbucks ethically sources coffee.</span></li>
                <li><span class="font-black">Learn how Starbucks roasts and blends coffee.</span></li>
                <li><span class="font-black">Explore the different factors that influence a perfectly brewed cup of coffee.</span></li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "SubIntroComponent"
}
</script>
